import { useState } from 'react';
import CustomSelect from '../ui/CustomSelect';
import { Link as LinkIcon } from 'lucide-react';
import PropertyPillField from './PropertyPillField';
import usePropertyStore from '../../stores/usePropertyStore';
import './PropertyField.css';

export default function PropertyField({ property, value, onChange, readOnly = false }) {
    if (!property) return null;

    const addOptionToProperty = usePropertyStore(s => s.addOptionToProperty);

    // Create a new option on-the-fly and return it
    const handleCreateOption = (label) => {
        if (!property.id || property.id.startsWith('__')) return null; // Skip system properties
        return addOptionToProperty(property.id, { label });
    };

    const renderInput = () => {
        if (readOnly) {
            // Read-only visualization
            if (property.type === 'select' || property.type === 'multi-select') {
                return (
                    <PropertyPillField
                        type={property.type}
                        value={value}
                        options={property.options || []}
                        readOnly={true}
                    />
                );
            }
            if (property.type === 'url' && value) {
                return <a href={value} target="_blank" rel="noopener noreferrer" className="property-field-link"><LinkIcon size={12}/> {value}</a>;
            }
            return <span className="property-field-readonly">{value || <span className="empty">Empty</span>}</span>;
        }

        switch (property.type) {
            case 'text':
                return (
                    <input 
                        className="property-field-input"
                        type="text" 
                        value={value || ''} 
                        onChange={e => onChange(e.target.value)} 
                        placeholder="Empty"
                    />
                );
            case 'number':
                return (
                    <input 
                        className="property-field-input"
                        type="number" 
                        value={value || ''} 
                        onChange={e => onChange(e.target.value ? Number(e.target.value) : '')} 
                        placeholder="0"
                    />
                );
            case 'url':
                return (
                    <div className="property-field-url-wrapper">
                        <LinkIcon size={14} className="text-muted" />
                        <input 
                            className="property-field-input"
                            type="url" 
                            value={value || ''} 
                            onChange={e => onChange(e.target.value)} 
                            placeholder="https://"
                        />
                    </div>
                );
            case 'select':
            case 'multi-select':
                return (
                    <PropertyPillField 
                        type={property.type}
                        value={value}
                        options={property.options || []}
                        onChange={onChange}
                        onCreateOption={property.id && !property.id.startsWith('__') ? handleCreateOption : undefined}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <div className="property-field-wrapper">
            {renderInput()}
        </div>
    );
}

